import { Accordion, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import React from "react";
import VerBusinessDetails from "../../../components/common/VerBusinessDetails";
const VerCommunicationAddress: React.FC = () => {
  const state = useSelector(
    (state: RootState) => state.verification.verCommAddressDetails
  );
  const getAppSelector = useSelector(
    (state: RootState) => state.opsPpIndApp.getApp
  );
  const shippingAddrId = getAppSelector.data.business_shipping_address_type_id;
  const billingAddrId = getAppSelector.data.business_billing_address_type_id;
  const isIndia =
    getAppSelector.data.business_registration_country_id ===
    Number(process.env.REACT_APP_COUNTRY_ID);
  if (!state.data || !state.data.data) {
    return <Row>Loading...</Row>;
  }
  const commAddressDetailsStore: Array<{
    id: number;
    line_1: string;
    line_2: string;
    city: string;
    district: string;
    state: string;
    pincode: string;
    country_id: { name: string };
    phone: string;
    phone_country_code: string;
    email: string;
    billing_gstn: string;
    business_billing_gstn: string;
    business_billing_preference_email: string;
    business_communication_preference_email: string;
    api_com_line_1_flag: boolean;
    api_com_line_2_flag: boolean;
    api_com_pincode_flag: boolean;
    api_com_city_flag: boolean;
    api_com_district_flag: boolean;
    api_com_state_flag: boolean;
    api_com_country_flag: boolean;
    // api_com_country_flag: boolean;
  }> = state.data.data.result.result;
  return (
    <Accordion>
      {commAddressDetailsStore.map((address, index) => (
        <Accordion.Item key={index} eventKey={`C${index}`}>
          <Accordion.Header>Communication Address {index + 1}</Accordion.Header>
          <Accordion.Body>
            <Row md={12}>
              <Col md={12}>
                <VerBusinessDetails
                  label="Address Line 1"
                  defaultValue={address.line_1}
                  required
                  colored={address.api_com_line_1_flag}
                />
              </Col>
            </Row>
            <Row md={12}>
              <Col md={12}>
                <VerBusinessDetails
                  label="Address Line 2"
                  defaultValue={address.line_2}
                  required
                  colored={address.api_com_line_2_flag}
                />
              </Col>
            </Row>
            <Row md={12}>
              <Col md={6}>
                {/* <VerBusinessDetails label="City" defaultValue={address.city} /> */}
                <VerBusinessDetails
                  label="City"
                  defaultValue={address.city}
                  colored={address.api_com_city_flag}
                  required
                />
              </Col>
              <Col md={6}>
                <VerBusinessDetails
                  label="District"
                  defaultValue={address.district}
                  colored={address.api_com_district_flag}
                  required
                />
              </Col>
            </Row>
            <Row md={12}>
              <Col md={6}>
                <VerBusinessDetails
                  label="State/ County"
                  defaultValue={address.state}
                  colored={address.api_com_state_flag}
                  required
                />
              </Col>
              <Col md={6}>
                <VerBusinessDetails
                  label="Country"
                  defaultValue={address.country_id.name}
                  colored={address.api_com_country_flag}
                  required
                />
              </Col>
            </Row>
            <Row md={12}>
              <Col md={12}>
                <VerBusinessDetails
                  label="Email"
                  defaultValue={address.email}
                  required
                />
              </Col>
            </Row>
            <Row md={12}>
              <Col md={6}>
                <VerBusinessDetails
                  label="PIN/ ZIP Code"
                  defaultValue={address.pincode}
                  colored={address.api_com_pincode_flag}
                  required
                />
              </Col>
              <Col md={6}>
                <VerBusinessDetails
                  label="Cellphone"
                  defaultValue={address.phone_country_code + -+address.phone}
                  required
                />
              </Col>
            </Row>
            {isIndia && (
              <Row md={12}>
                <Col md={12}>
                  <VerBusinessDetails
                    label="Billing GSTIN"
                    defaultValue={address.business_billing_gstn}
                  />
                </Col>
              </Row>
            )}
            <Row md={12}>
              <Col md={12}>
                <VerBusinessDetails
                  label="Billing Preference"
                  defaultValue={address.business_billing_preference_email}
                  required
                />
              </Col>
            </Row>
            <Row md={12}>
              <Col md={12}>
                <VerBusinessDetails
                  label="Communication Preference"
                  defaultValue={address.business_communication_preference_email}
                  required
                />
              </Col>
            </Row>
            <Row md={12}>
              <Col md={6}>
                <VerBusinessDetails
                  label="Is Shipping Address"
                  defaultValue={address.id === shippingAddrId ? "Yes" : "No"}
                />
              </Col>
              <Col md={6}>
                <VerBusinessDetails
                  label="Is Billing Address"
                  defaultValue={address.id === billingAddrId ? "Yes" : "No"}
                />
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
};
export default VerCommunicationAddress;
